import { makeStyles } from '@material-ui/core';

export const useLocationStyles = makeStyles(() => ({
  title: {
    fontSize: 14
  }
}));
